module.exports = __webpack_public_path__ + "media/images/emblems/Schoetz_LU-75e5a12fcd42a8f260caf59329decff1.png";